module.exports = __webpack_public_path__ + "img/52.2d2630a2.jpg";